import script from "./SearchPanelToggleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPanelToggleButton.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPanelToggleButton.vue?vue&type=style&index=0&id=5a2ade91&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a2ade91"]])

export default __exports__